import styled, { css } from 'styled-components';
// import theme from 'src/theme';

type StatusProps = {
    rightPos?: string;
    inList?: boolean;
    inButton?: boolean;
    inTab?: boolean;
};

export interface IButtonProps {
    isSelected?: boolean;
    disabled?: boolean;
    altColor?: boolean;
    onClick?: (eventTypeId: number) => void;
}
export interface WarningProps {
    isReadOnly?: boolean;
    isWarning?: boolean;
}

export const StatusText = styled.span<StatusProps>`
    .status-icon {
        border-radius: 50%;
        color: #fff;
        width: 10px;
        height: 10px;
        padding: 2px;
        font-size: 8px;
        margin-right: 5px;
        display: inline-block;
    }

    &.status-ongoing-voyage .status-icon {
        background: grey;
    }
    &.status-internal-issues .status-icon {
        background: red;
    }
    &.status-ready-for-verification .status-icon {
        background: lightskyblue;
    }
    &.status-sent .status-icon {
        background: #873a45;
    }
    &.status-verified .status-icon {
        background: green;
    }
    &.status-issues .status-icon {
        background: darkorange;
    }
    &.status-new-version .status-icon {
        background: #9be577;
    }
`;

export const SortButtonSmall = styled.button<IButtonProps>`
    font-size: 0.8rem;
    color: #04265a;
    border: 0;
    cursor: pointer;
    padding: 1px 6px;
    margin: 6px;
    border: 1px solid #ddd;
    text-align: center;

    ${({ isSelected }) =>
        isSelected &&
        css`
            background: #0aa5dc;
            color: #fff;
            border: 1px solid #0b97c9;
        `}
`;

export const RedIcon = styled.span`
    position: absolute;
    top: 0;
    right: 0;
    font-weight: 500;
    font-size: 10px;
    font-family: arial;
    background: orangered;
    color: #fff;
    width: 15px;
    height: 15px;
    text-align: center;
    border-radius: 50%;
    padding: 0px 2px 2px 2px;
`;

export const ErrorInfoIconStyle = styled.span<WarningProps>`
    position: absolute;
    bottom: -7px;
    right: 32px;
    color: red;
    border: 0;
    z-index: 1;
    ${({ isReadOnly }) =>
        isReadOnly &&
        css`
            bottom: -5px;
            right: 10px;
    `}
    ${({ isWarning }) =>
        isWarning &&
        css`
            color: orange;
            z-index: 0;
    `}
    font-size: 0.75rem;
 `;